import axios from 'axios'
import $store from '@/store/store.js'

const token = () => {
	let user = $store.getters.user
	return user.maestroAuth
}

const ApiAcme = {
	install (Vue, options) {
		Vue.prototype.$ApiAcme = {
			patron_apply (patron, against) {
				return new Promise((resolve, reject) => {
					let options = {
						baseURL: `${window.appConfig._$o13o0d}api/patron/${patron}/apply/?${against}`,
						method: 'get',
						headers: { Authorization: `Token ${token()}` }
					}
					axios(options)
						.then(response => {
							resolve(response)
						})
						.catch(error => {
							reject(error)
						})
				})
			}
		}
	}
}

export default ApiAcme



// WEBPACK FOOTER //
// ./src/api/acme_api.js